import Model from "../Model";

class KpiComercialGraphsZone extends Model{

    buildUrl ({ param }) {
        return ['kpizone/getbyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiComercialGraphsZone;